import { jsx as _jsx } from "react/jsx-runtime";
import Svg from '../../Svg';
const SendIcon = ({ size, ...rest }) => {
    return (_jsx(Svg, { size: size, viewBox: "0 0 24 24", fill: "none", ...rest, children: _jsx("path", { d: "M18 12L6 7.5V10.5L18 12ZM18 12L6 16.5V13.5L18 12Z", stroke: "currentColor", strokeWidth: "0.9375" }) }));
};
export default SendIcon;
//# sourceMappingURL=SendIcon.js.map